module.exports = __webpack_public_path__ + "static/logo-aa60db26183fb8f9c093060b7a3b5754.png";